__turbopack_context__.v({
  "content": "dialog-motion-module__9sWqBa__content",
  "dialogContentIn": "dialog-motion-module__9sWqBa__dialogContentIn",
  "dialogContentOut": "dialog-motion-module__9sWqBa__dialogContentOut",
  "dialogOverlayIn": "dialog-motion-module__9sWqBa__dialogOverlayIn",
  "dialogOverlayOut": "dialog-motion-module__9sWqBa__dialogOverlayOut",
  "overlay": "dialog-motion-module__9sWqBa__overlay",
});
